// Ponto UNICO de import() dinamico das telas publicas do questionario.
//
// Por que existe: o chunk do QuizSteps (~64KB gzip) so comecava a baixar no
// clique do "Iniciar", criando uma espera que nao existia antes das rotas
// virarem lazy. A solucao e pre-carregar esse chunk enquanto a pessoa le a
// primeira tela - mas o import() PRECISA ser o mesmo call site usado pela
// rota. Com dois import() do mesmo modulo em arquivos diferentes (um em
// routes.js, outro dentro da tela Quiz), o webpack gera DOIS chunks com o
// mesmo codigo: o preload baixaria um e a rota continuaria baixando o outro
// no clique - pior que nao ter preload (verificado comparando os builds:
// 37 chunks -> 39, com o codigo do QuizSteps duplicado).
//
// Mantendo a funcao aqui, routes.js e Quiz usam a MESMA referencia: um chunk
// so, e a promessa do webpack ja fica em cache quando a rota precisar dele.

export const importQuizSteps = () => import('./pages/QuizSteps');
export const importQuizThanks = () => import('./pages/QuizThanks');
